module.exports = __webpack_public_path__ + "static/img/run2023.77a8f73a.jpg";